module.exports = __webpack_public_path__ + "img/kenya.94756aba.svg";